import { Link } from "react-router";

export function NotFoundPage() {
	return (
		<div
			data-testid="not-found-page"
			style={{
				minHeight: "100vh",
				background: "var(--surface-2)",
				display: "grid",
				placeItems: "center",
				fontFamily: "var(--font-sans)",
				padding: 24,
			}}
		>
			<div
				style={{
					width: "100%",
					maxWidth: 400,
					background: "var(--surface-1)",
					borderRadius: "var(--radius-5)",
					boxShadow: "var(--shadow-card)",
					padding: "40px 32px",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 16,
					textAlign: "center",
				}}
			>
				<span
					style={{
						fontSize: "var(--text-splash)",
						fontWeight: 600,
						lineHeight: "var(--leading-none)",
						letterSpacing: "var(--tracking-display)",
						color: "var(--fg-1)",
						fontFamily: "var(--font-mono)",
					}}
				>
					404
				</span>
				<h1
					style={{
						margin: 0,
						fontSize: "var(--text-display)",
						fontWeight: 600,
						lineHeight: "var(--leading-snug)",
						letterSpacing: "var(--tracking-display)",
						color: "var(--fg-1)",
					}}
				>
					ページが見つかりません
				</h1>
				<p
					style={{
						margin: 0,
						fontSize: "var(--text-ui)",
						color: "var(--fg-2)",
						lineHeight: "var(--leading-ui)",
					}}
				>
					お探しのページは存在しないか、移動した可能性があります。
				</p>
				<Link
					to="/"
					style={{
						marginTop: 8,
						height: 34,
						padding: "0 16px",
						display: "inline-flex",
						alignItems: "center",
						fontSize: "var(--text-ui)",
						fontWeight: 500,
						color: "var(--on-accent-solid)",
						background: "var(--accent-solid)",
						borderRadius: "var(--radius-3)",
						textDecoration: "none",
						transition: "background 150ms ease",
					}}
					onMouseEnter={(e) => {
						e.currentTarget.style.background = "var(--accent-solid-hover)";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.background = "var(--accent-solid)";
					}}
				>
					ホームに戻る
				</Link>
			</div>
		</div>
	);
}
